// extracted by mini-css-extract-plugin
module.exports = {"tableHead":"Table_tableHead__2PMn9","bigColWidth":"Table_bigColWidth__2m19k","biggerColWidth":"Table_biggerColWidth__2wcr_","row":"Table_row__21gsz","col":"Table_col__ho19L"};